import { convertFileToBase64 } from '@shared/utils';
import KelvinColor from '@shared/utils/KelvinColor';

const ENDPOINT = '/ai-products';

class AiProductsApi {
  constructor(http) {
    this.http = http;
  }

  getAiProducts = async () => {
    return this.http.get(`${ENDPOINT}`);
  }

  getAiProduct = async (id) => {
    return this.http.get(`${ENDPOINT}/${id}`);
  }

  createAiProduct = async (product) => {
    return this.http.post(ENDPOINT, {
      ...product,
      id: undefined,
    });
  }

  updateAiProduct = async (product) => {
    return this.http.put(`${ENDPOINT}/${product.id}`, {
      ...product,
    });
  }

  deleteAiProduct = (id) => this.http.delete(`${ENDPOINT}/${id}`)

  processAiProduct = async (id, config) => {
    return this.http.post(`${ENDPOINT}/${id}/process`, config);
  }
}

export default AiProductsApi;
